import React from 'react';
import { Link } from 'react-router-dom';

interface AuthLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

const AuthLink: React.FC<AuthLinkProps> = ({
  to,
  children,
  className = '',
}) => {
  const baseClasses = 'font-medium text-blue-600 hover:text-blue-500';

  return (
    <Link to={to} className={`${baseClasses} ${className}`}>
      {children}
    </Link>
  );
};

export default AuthLink;
